"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabbables = void 0;
/**
 * list of the object to be considered as focusable
 */

exports.tabbables = ['button:enabled', 'select:enabled', 'textarea:enabled', 'input:enabled', // elements with explicit roles will also use explicit tabindex
// '[role="button"]',
'a[href]', 'area[href]', 'summary', 'iframe', 'object', 'embed', 'audio[controls]', 'video[controls]', '[tabindex]', '[contenteditable]', '[autofocus]'];